// extracted by mini-css-extract-plugin
export var card = "_jp-5";
export var cardSelected = "_jp-4";
export var image = "_jp-3";
export var modal = "_jp-0";
export var modalContent = "_jp-1";
export var table = "_jp-2";